import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import { alterarItemContrato } from '~/Services/Juridico/ControleContratoService';
import { schemaAlterarItem } from './validationSchemas';
import { extrairMensagemErro } from './useControleContrato';

const ModalAlterarItem = ({ show, onHide, contrato, item, onSalvo }) => {
  if (!contrato) return null;

  const hoje = new Date().toISOString().slice(0, 10);

  const valoresIniciais = {
    dataItem: item ? item.data_item || hoje : hoje,
    novoTitulo: item ? item.titulo || '' : '',
    novaObs: item ? item.observacao || '' : '',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await alterarItemContrato({
        codigoGrupoEmpresa: contrato.codigo_grupo_empresa,
        codigoConta: contrato.conta,
        codigoBoleto: contrato.boleto,
        dataItem: values.dataItem,
        novoTitulo: values.novoTitulo,
        novaObs: values.novaObs || null,
      });
      toast.success('Item alterado com sucesso.');
      onSalvo();
    } catch (err) {
      toast.error(extrairMensagemErro(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Alterar Item do Contrato</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={valoresIniciais}
        validationSchema={schemaAlterarItem}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ handleSubmit: formSubmit, isSubmitting }) => (
          <Form onSubmit={formSubmit}>
            <Modal.Body>
              <Row>
                <Col xs={12} sm={5}>
                  <Form.Group>
                    <Form.Label className="small mb-1">Data *</Form.Label>
                    <Field
                      as={Form.Control}
                      size="sm"
                      type="date"
                      name="dataItem"
                    />
                    <ErrorMessage name="dataItem">
                      {(msg) => <small className="text-danger">{msg}</small>}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group>
                <Form.Label className="small mb-1">Título *</Form.Label>
                <Field
                  as={Form.Control}
                  size="sm"
                  type="text"
                  name="novoTitulo"
                  maxLength={30}
                />
                <ErrorMessage name="novoTitulo">
                  {(msg) => <small className="text-danger">{msg}</small>}
                </ErrorMessage>
              </Form.Group>
              <Form.Group>
                <Form.Label className="small mb-1">Observação</Form.Label>
                <Field
                  as="textarea"
                  className="form-control form-control-sm"
                  name="novaObs"
                  rows={3}
                  maxLength={2000}
                />
                <ErrorMessage name="novaObs">
                  {(msg) => <small className="text-danger">{msg}</small>}
                </ErrorMessage>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" size="sm" onClick={onHide} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button variant="primary" size="sm" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Alterar'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalAlterarItem;
